import { createEntityDenormalizer } from '@iconik-io/shared-lib/src/redux/entities/normalizers';

export const denormalizeSearchItem = createEntityDenormalizer('search_items');
